module.exports = __webpack_public_path__ + "static/media/cert-IAC2.137a59c1.png";